/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "blustreamREST",
            "endpoint": "https://vo8hqioqvk.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "publicshorturl",
            "endpoint": "https://ntxvykyf80.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://4masiyvlhnejnmjle44gzzmv6i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_appsync_apiKey": "da2-7ujl6quvijcclonlzna5tkvkoy",
    "aws_cognito_identity_pool_id": "us-east-1:e227ac8e-4f4b-4bd5-85ce-46e16c05b3c2",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_e2aKSjKbV",
    "aws_user_pools_web_client_id": "7ekdoua5fo782dgjimqg8gm1gj",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "blustreamfrontend-20211126150112-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3i8v3eaf61b62.cloudfront.net",
    "aws_user_files_s3_bucket": "blustreamfrontenda4c26b55bbdb40489dfdc2867d6081215211-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
